export default __webpack_public_path__ + "static/media/download.848faaca.svg";